import React, {useEffect, useRef} from "react";
import ReactHtmlParser from "react-html-parser";

import step from "../StepOne/styles/step.module.scss";
import styles from "./styles/styles.module.scss";
import { useCalc } from "../../store/hooks/useCalc";
import {round, roundTwo} from "../../helpers";
import {scrollToRef} from "../../helpers/scrollToRef";

import text from "../../helpers/useText";

export const StepThree = () => {
  let stepThreeRef = useRef();
  const { clearAll, calc } = useCalc();
  const { dataArr, kefArray, kefStatus, totalSumArr, totalCofArr, totalWinning, itemBet } = calc();

  useEffect(() => {
    scrollToRef(stepThreeRef);
  }, [dataArr]);

  // handlers
  const handlerClearAll = (e) => {
    e.preventDefault();
    clearAll();
  };

  const tableHeader = <div className={`${styles.step_three__table_head}`}>
    <div>#</div>
    {
      kefArray.map((item, i) => {
        return (
          <div key={`kof_${i}`} className={kefStatus[i] === 0 ? `${styles.step_three__table_head_red}` : ""}>{
            item ? roundTwo(item) : '-'
          }</div>
        )
      })
    }
    <div>{text.stepThree.odds}</div>
    <div>{text.stepThree.stake}</div>
    <div>{text.stepThree.win}</div>
  </div>;

  const tableRows = dataArr.map((item, index) => {
    return (
      <div className={styles.step_three__table_row} key={`key${index}`}>
        <div>{index+1}</div>
        {
          /*render items coef*/
          item.map((item, j) => {
            let cof = ' ';
            if (item === 0) {
              cof = roundTwo(kefArray[j])
            } else if (item === ' ') {
              cof = ' ';
            } else {
              cof = roundTwo(item)
            }

            return (
              <div className={item === 0 ? `${styles.step_three__table_red}` : ""} key={`key${j}`}>
                { cof }
              </div>
            );
          })
        }
        <div>{totalCofArr[index]}</div>
        <div>{round(itemBet)}</div>
        <div>{totalSumArr[index]}</div>
      </div>
    )
  });

  const tableFirstCol = (
    <div className={styles.step_three__first_col}>
      <div><div>#</div></div>
      {
        dataArr.map((item, index) => (<div key={index}><div>{index+1}</div></div>))
      }
    </div>
  );


  return (
    <div className={styles.step_three} ref={stepThreeRef}>
      <div className={step.step__header}>
        <div className={step.step__title}>{text.stepThree.title}</div>
      </div>
      <div className={step.step__description}>
        { ReactHtmlParser(text.stepThree.description) }
      </div>
      <div className={styles.step_three__content}>
        {tableFirstCol}
        <div className={styles.step_three__content_scroll}>
          <div className={styles.step_three__table}>
            { tableHeader }
            { tableRows }
          </div>
        </div>
      </div>
      <div className={styles.step_three__footer}>
        <div className={styles.step_three__footer_description}>{text.stepThree.info}</div>
        <div className={styles.step_three__footer_bottom}>
          <div className={styles.step_three__winning}>
            {text.stepThree.total}<span>{ round(totalWinning) }</span>
          </div>
          <div className={styles.step_three__footer_action}>
            <button className="c-btn c-btn--primary" type="button" onClick={(e) => handlerClearAll(e)}>
              <div className="c-btn__text"><span className="ico-reset"/>{text.stepThree.clear}</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};
